// Training Classes Data
export const trainingClasses = [
  {
    id: "small-group",
    title: "Small Group Training",
    badge: "Popolare",
    description: "Allenati in piccoli gruppi di massimo 4 persone. Ottieni i benefici del personal training con la motivazione del gruppo.",
    benefits: [
      "Gruppi max 4 persone",
      "Programmi semi-personalizzati",
      "Atmosfera motivante",
      "Costo accessibile",
      "Orari flessibili"
    ],
    details: {
      duration: "60 minuti",
      frequency: "3-4 volte/settimana",
      level: "Principiante - Intermedio"
    },
    image: "https://images.unsplash.com/photo-1571902943202-507ec2618e8f"
  },
  {
    id: "hiit-performance",
    title: "HIIT Performance",
    badge: "Intenso",
    description: "Allenamenti ad alta intensità progettati per massimizzare il consumo calorico e migliorare le performance atletiche.",
    benefits: [
      "Massima intensità",
      "Risultati rapidi",
      "Migliora resistenza",
      "Brucia grassi efficacemente",
      "Sessioni dinamiche"
    ],
    details: {
      duration: "45 minuti",
      frequency: "3-5 volte/settimana",
      level: "Intermedio - Avanzato"
    },
    image: "https://images.unsplash.com/photo-1549476464-37392f717541"
  },
  {
    id: "functional-training",
    title: "Allenamento Funzionale",
    badge: "Completo",
    description: "Movimenti multi-articolari che migliorano forza, mobilità e coordinazione per le attività quotidiane e sportive.",
    benefits: [
      "Migliora mobilità",
      "Previene infortuni",
      "Forza applicata",
      "Movimenti naturali",
      "Adatto a tutti"
    ],
    details: {
      duration: "60 minuti",
      frequency: "2-4 volte/settimana",
      level: "Tutti i livelli"
    },
    image: "https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5"
  }
];
